import React from 'react'

export default function Servicios() {
  return (
    <div>
        <div className="heros bg-base-200 min-h-screen display-serv">
          <div>
          <div style={{marginBottom:'4rem', marginTop:'5rem'}}>
          <h1 className="text-5xl font-bold">Tecnología de Punta para una Experiencia Superior</h1>
          </div>
  <div className="hero-content text-center">
  <div className="card bg-base-100 w-96 shadow-xl">
  <figure>
    <img
      src="img/bus-t.jpg"
      alt="Shoes" />
  </figure>
  <div className="card-body">
    <h2 className="card-title">Optimización del Tiempo</h2>
    <p>Busia utiliza algoritmos inteligentes para optimizar las rutas, reducir los tiempos de espera y ofrecer un servicio rápido y eficiente.</p>
    <div className="card-actions justify-end">
      <button className="btn btn-primary">Buy Now</button>
    </div>
  </div>
</div>

<div className="card bg-base-100 w-96 shadow-xl">
  <figure>
    <img
      src="img/buses.jpg"
      alt="Shoes" />
  </figure>
  <div className="card-body">
    <h2 className="card-title">Gestión de Transporte </h2>
    <p>Sistema integral que permite el pago electrónico en buses, micros y colectivos, junto con una plataforma avanzada de gestión de flota que optimiza la.</p>
    <div className="card-actions justify-end">
      <button className="btn btn-primary">Buy Now</button>
    </div>
  </div>
</div>

<div className="card bg-base-100 w-96 shadow-xl">
  <figure>
    <img
      src="img/bus-seguro.jpg"
      alt="Shoes" />
  </figure>
  <div className="card-body">
    <h2 className="card-title">Seguridad y Confiabilidad</h2>
    <p>La plataforma prioriza la seguridad y la confiabilidad, con vehículos y conductores verificados para garantizar una experiencia segura y confiable.</p>
    <div className="card-actions justify-end">
      <button className="btn btn-primary">Buy Now</button>
    </div>
  </div>
</div>



<div className="card bg-base-100 w-96 shadow-xl">
  <figure>
    <img
      src="img/bus-wifi.jpg"
      alt="Shoes" />
  </figure>
  <div className="card-body">
    <h2 className="card-title">Conectividad Satelital</h2>
    <p>Cada unidad está equipada con internet satelital de alta velocidad, garantizando una conexión constante y confiable para los pasajeros.</p>
    <div className="card-actions justify-end">
      <button className="btn btn-primary">Buy Now</button>
    </div>
  </div>
</div>
</div>

  </div>
</div>
      
    </div>
  )
}
